module.exports = __webpack_public_path__ + "img/marker_info.1a3a8004.svg";